export function competenciaAtual(): string {
  const hoje = new Date();
  return `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, '0')}`;
}

export function opcoesMes(): { value: string; label: string }[] {
  const hoje = new Date();
  return Array.from({ length: 12 }, (_, i) => {
    const data = new Date(hoje.getFullYear(), hoje.getMonth() - i, 1);
    const competencia = `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, '0')}`;
    const rotulo = data.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });
    return { value: competencia, label: rotulo.charAt(0).toUpperCase() + rotulo.slice(1) };
  });
}

export const MESES = opcoesMes();
